/**
 * Nav item keys (from internal/core/config/navigation_registry.py) that have
 * a real React page now. Sidebar uses this to route internally (client-side)
 * instead of full-page-navigating to the still-live legacy Flask page for
 * that same nav slot. Grows by one entry per page as the migration
 * progresses; a key absent here just falls through to its legacy `href`.
 */
export const MIGRATED_ROUTES: Record<string, string> = {
  clients: '/companies',
  controllers: '/iot-management',
  controller_directory: '/controllers',
  microgrids: '/microgrids',
  users: '/users',
  privileges: '/privileges',
  permissions: '/permissions',
  consolidation: '/consolidation',
  alarm_topics: '/alarm-topics',
  report_groups: '/report-groups',
  controller_status: '/controller-status',
  maintenance: '/maintenance',
  monthly_reports: '/monthly-reports',
  fleet_alarm_subscriptions: '/fleet-alarm-subscriptions',
  fleet_alarm_subscriptions_manage: '/fleet-alarm-subscriptions/manage',
}
